import type { ContactFormData } from '../../../types/contact';
import type { TrainingFormData } from '../../../types/training';

export const validateContactForm = (data: ContactFormData): boolean => {
  const requiredFields = ['name', 'email', 'company', 'phone', 'product', 'service', 'message'];
  
  // Check required fields
  for (const field of requiredFields) {
    if (!data[field as keyof ContactFormData]?.trim()) {
      return false;
    }
  }
  
  // Validate email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(data.email)) {
    return false;
  }
  
  // Validate phone format (basic check)
  const phoneRegex = /^[+]?[\d\s-()]{8,}$/;
  if (!phoneRegex.test(data.phone)) {
    return false;
  }
  
  return true;
};

export const validateTrainingRequest = (data: TrainingFormData): boolean => {
  const requiredFields = ['name', 'email', 'company', 'participants', 'trainingType'];
  
  // Check required fields
  for (const field of requiredFields) {
    if (!data[field as keyof TrainingFormData]?.trim()) {
      return false;
    }
  }
  
  // Validate email format
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(data.email)) {
    return false;
  }
  
  // Validate participants number
  const participants = parseInt(data.participants);
  if (isNaN(participants) || participants < 1) {
    return false;
  }
  
  return true;
};